import styles from './Dashboard.module.scss'

export default function Dashboard() {
	return (
		<div className={styles.dashboard_wrapper}>
			dashboard
		</div>
	)
}
